module.exports = __webpack_public_path__ + "img/banner.426fb1d6.jpg";